import {connect} from "react-redux";
import ActivityView from "./view";
import {bindActionCreators} from "redux";
import {viewActivity} from "../../../service/Activity/action";
import {addTaggedAlong} from "../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    activityByIdDetails:state.Activity.activityByIdDetails,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewActivity,
            addTaggedAlong
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ActivityView);
